import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'

import { isBlank } from 'utils'

import Button from 'components/Button'
import Spacer from 'components/Spacer'
import Text from 'components/Text'

import { Description, Root } from './ProductDescription.style'

const singleParagraphRegex = /<p>.*<\/p>/g

const ProductDescription = ({ html }) => {
  const [isExpanded, setIsExpanded] = useState(true)

  useEffect(() => {
    setIsExpanded(singleParagraphRegex.test(html))
  }, [html])

  if (isBlank(html)) return null

  return (
    <Root>
      <Description $isExpanded={isExpanded}>
        <Text html={html} />
      </Description>
      {!isExpanded && (
        <>
          <Spacer y={2} />
          <Button text="More…" variant="inline" onClick={() => setIsExpanded(true)} />
        </>
      )}
    </Root>
  )
}

ProductDescription.propTypes = {
  html: PropTypes.string,
}

ProductDescription.defaultProps = {}

export default ProductDescription
